import { Component, OnInit,ViewEncapsulation,Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FilterOverlayDialogService } from './filter-overlay-dialog.service';
import { NotificationRecipientsTableComponent } from '../notification-recipients-table/notification-recipients-table.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppUtils } from 'projects/dialog/src/app/shared/utilities/app-utils';
export interface FilterOptions {
  statusFilters: string[];
  dateSent_sdate:string;
  dateSent_edate:string;
  dateDelivered_sdate:string;
  dateDelivered_edate:string;
  dateRead_sdate:string,
  dateRead_edate:string,
  feedbackReceived_sdate:string,
  feedbackReceived_edate:string
}
@Component({
  selector: 'dl-filter-overlay-dialog',
  templateUrl: './filter-overlay-dialog.component.html',
  styleUrls: ['./filter-overlay-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FilterOverlayDialogComponent implements OnInit {

  public filterForm: FormGroup;
  public width = '255px';
  public formDisabled = false;
  public statusFormControl = new FormControl();
  public dateSent_startDate = new FormControl('');
  public dateSent_endDate = new FormControl('');
  public feedbackReceived_startdate = new FormControl('');
  public feedbackReceived_endDate = new FormControl('');
  public dateRead_startDate = new FormControl('');
  public dateRead_endDate = new FormControl('');
  public dateDelivered_startDate = new FormControl('');
  public dateDelivered_endDate = new FormControl('');
  public statusPlaceholder = 'Select status';
  public statusFilters: [];
  public filterDataObject: FilterOptions;
  statusList = [];
  recipientFilters = {
    statusFilters:[
    ],
    dateSent:{
    startDate: this.dateSent_startDate.value,
    endDate: this.dateSent_endDate.value
    },
    dateDelivered:{
    startDate:this.dateDelivered_startDate.value,
    endDate:this.dateDelivered_endDate.value
    },
    dateRead:{
    startDate:this.dateRead_startDate.value,
    endDate:this.dateRead_endDate.value
    },
    feedbackReceived:{
    startDate:this.feedbackReceived_startdate.value,
    endDate:this.feedbackReceived_endDate.value
    }
    }

  constructor( public appUtils:AppUtils,private readonly dialog: MatDialog, public dialogRef: MatDialogRef<FilterOverlayDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,public filterOverlay:FilterOverlayDialogService) {
    this.filterDataObject = {  statusFilters: [],dateSent_sdate:'',dateSent_edate:'',dateDelivered_sdate:'',dateDelivered_edate:'',dateRead_sdate:'',dateRead_edate:'',feedbackReceived_sdate:'',feedbackReceived_edate:''};
  }
  clearForm() {
    this.dateSent_startDate.setValue('');
    this.dateSent_endDate.setValue('');
    this.feedbackReceived_startdate.setValue('');
    this.feedbackReceived_endDate.setValue('');
    this.dateRead_startDate.setValue('');
    this.dateRead_endDate.setValue('');
    this.dateDelivered_startDate.setValue('');
    this.dateDelivered_endDate.setValue('');
    this.statusFormControl.setValue('');
  }
  ngOnInit(): void {
   if(this.data){
      this.filterDataObject = this.data;
      this.dateSent_startDate.setValue(this.data.dateSent_sdate);
      this.dateSent_endDate.setValue(this.data.dateSent_edate);
      this.feedbackReceived_startdate.setValue( this.data.feedbackReceived_sdate);
      this.feedbackReceived_endDate.setValue(this.data.feedbackReceived_edate);
      this.dateRead_startDate.setValue(this.data.dateRead_sdate);
      this.dateRead_endDate.setValue(this.data.dateRead_edate);
      this.dateDelivered_startDate.setValue(this.data.dateDelivered_sdate);
      this.dateDelivered_endDate.setValue(this.data.dateDelivered_edate);
      const statusDataSelected = this.setStatusData(this.data.statusFilters);
      this.statusFormControl.setValue(statusDataSelected);
    }
   this.statusFormControl.valueChanges.subscribe(val => {
      if (val && val.length > 0) {
        this.recipientFilters.statusFilters = val.map(item => item.label.trim());
        this.filterDataObject.statusFilters = this.recipientFilters.statusFilters;
      } else {
        this.filterDataObject.statusFilters = [];
      }
    });
    this.filterOverlay.statusFilterobservable$.subscribe(selStatus => {
      this.statusList = selStatus;
      return;
    });

    this.dateSent_startDate.valueChanges.subscribe(val => {
      if (this.appUtils.formatDateOnly(val) && this.appUtils.formatDateOnly(val).length > 0) {
        this.recipientFilters.dateSent.startDate = val;
        this.filterDataObject.dateSent_sdate =  this.recipientFilters.dateSent.startDate;
      } else {
        this.filterDataObject.dateSent_sdate = '';
      }
    });
    this.dateSent_endDate.valueChanges.subscribe(val => {
      if (this.appUtils.formatDateOnly(val) && this.appUtils.formatDateOnly(val).length > 0) {
        this.recipientFilters.dateSent.endDate = val;
        this.filterDataObject.dateSent_edate = this.recipientFilters.dateSent.endDate;
      }
      else {
        this.filterDataObject.dateSent_edate = '';
      }
    });
    this.dateDelivered_startDate.valueChanges.subscribe(val => {
      if (this.appUtils.formatDateOnly(val) && this.appUtils.formatDateOnly(val).length > 0) {
        this.recipientFilters.dateDelivered.startDate = val;
        this.filterDataObject.dateDelivered_sdate = this.recipientFilters.dateDelivered.startDate; 
      } else {
        this.filterDataObject.dateDelivered_sdate = '';
      }
    });
    this.dateDelivered_endDate.valueChanges.subscribe(val => {
       if (this.appUtils.formatDateOnly(val) && this.appUtils.formatDateOnly(val).length > 0) {
         this.recipientFilters.dateDelivered.endDate = val;
         this.filterDataObject.dateDelivered_edate = this.recipientFilters.dateDelivered.endDate;
       } else {
         this.filterDataObject.dateDelivered_edate = '';
       }
     });
      this.dateRead_startDate.valueChanges.subscribe(val => {
        if (this.appUtils.formatDateOnly(val) && this.appUtils.formatDateOnly(val).length > 0) {
          this.recipientFilters.dateRead.startDate = val;
          this.filterDataObject.dateRead_sdate = this.recipientFilters.dateRead.startDate;
        } else {
          this.filterDataObject.dateRead_sdate = '';
        }
      });
      this.dateRead_endDate.valueChanges.subscribe(val => {
        if (this.appUtils.formatDateOnly(val) && this.appUtils.formatDateOnly(val).length > 0) {
          this.recipientFilters.dateRead.endDate = val;
          this.filterDataObject.dateRead_edate = this.recipientFilters.dateRead.endDate;
        } else {
          this.filterDataObject.dateRead_edate = '';
        }
      });
      this.feedbackReceived_startdate.valueChanges.subscribe(val => {
        if (this.appUtils.formatDateOnly(val) && this.appUtils.formatDateOnly(val).length > 0) {
          this.recipientFilters.feedbackReceived.startDate = val;
          this.filterDataObject.feedbackReceived_sdate = this.recipientFilters.feedbackReceived.startDate;
        } else {
          this.filterDataObject.feedbackReceived_sdate = '';
        }
      });
      this.feedbackReceived_endDate.valueChanges.subscribe(val => {
        if (this.appUtils.formatDateOnly(val) && this.appUtils.formatDateOnly(val).length > 0) {
          this.recipientFilters.feedbackReceived.endDate = val;
          this.filterDataObject.feedbackReceived_edate = this.recipientFilters.feedbackReceived.endDate;
        } else {
          this.filterDataObject.feedbackReceived_edate = '';
        }
      });
  }
  public applyFilter(){
    this.filterOverlay.getFilteredData(this.filterDataObject);
  }
  public clearFRform(event){
    this.feedbackReceived_startdate.setValue('');
    this.feedbackReceived_endDate.setValue('');
    event.stopPropagation();
  }
  public clearDDform(event){
    this.dateDelivered_startDate.setValue('');
    this.dateDelivered_endDate.setValue('');
    event.stopPropagation();
  }
  public clearDSform(event){
    this.dateSent_startDate.setValue('');
    this.dateSent_endDate.setValue('');
    event.stopPropagation();
  }
  public clearDRform(event){
    this.dateRead_startDate.setValue('');
    this.dateRead_endDate.setValue('');
    event.stopPropagation();
  }
  public setStatusData(selectedStatus){
    let statusPreSlected = [];
    selectedStatus.forEach(status => {
      const statusObj = {
        label: status,
        value: status
      }
      statusPreSlected.push(statusObj)
    });
    return statusPreSlected;
  }

}

